import { render } from "./Batches.vue?vue&type=template&id=84662ea2&scoped=true"
import script from "./Batches.vue?vue&type=script&lang=js"
export * from "./Batches.vue?vue&type=script&lang=js"

import "./Batches.vue?vue&type=style&index=0&id=84662ea2&lang=scss&scoped=true"
import "./Batches.vue?vue&type=style&index=1&id=84662ea2&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/rust-webserver/rust-webserver/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-84662ea2"]])

export default __exports__